import { useState, useEffect } from 'react';

const WEBVONK_URL = 'https://swxfaqoftmwphbparotf.supabase.co';
const WEBVONK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN3eGZhcW9mdG13cGhicGFyb3RmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzk1MjY1OTQsImV4cCI6MjA5NTEwMjU5NH0.IZZAiD-ndE_CvkuY3E44N8Sm7u1EXnsYaYnCda6R-v4';
const getAuthToken = () => { try { return JSON.parse(localStorage.getItem('kmfc_user') || '{}')?.access_token; } catch { return null; } };

export function useBanner(companySlug) {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchBanner = async () => {
      const token = getAuthToken();
      const params = new URLSearchParams({ company_slug: `eq.${companySlug}`, active: 'eq.true', order: 'created_at.desc', limit: '1', select: '*' });
      const res = await fetch(`${WEBVONK_URL}/rest/v1/banners?${params}`, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'apikey': WEBVONK_ANON_KEY,
        },
      });
      const rows = res.ok ? await res.json() : [];
      const data = rows?.[0] || null;
      if (isMounted) {
        setBanner(data);
        if (data) {
          const stored = localStorage.getItem('kmfc_banner_dismissed');
          const { id, updatedAt } = stored ? JSON.parse(stored) : {};
          setDismissed(id === data.id && updatedAt === data.updated_at);
        }
      }
    };

    fetchBanner();
    return () => { isMounted = false; };
  }, [companySlug]);

  const dismiss = () => {
    if (banner) {
      localStorage.setItem('kmfc_banner_dismissed', JSON.stringify({ id: banner.id, updatedAt: banner.updated_at }));
    }
    setDismissed(true);
  };

  const visible = banner && (!banner.dismissable || !dismissed);

  return { banner, visible, dismiss };
}
